import ddpIcon from '../../../assets/ddpIcon.png'

interface CriteriaConfiguration {
    id: number
    value: string
    operator: string
    first_value: string | null
    second_value: string | null
}

interface SwitchCriteriaDetailProps {
    id: number
    name: string
    criteria_configurations: CriteriaConfiguration
}

export const SwitchCriteriaDetail = ({
    name,
    criteria_configurations,
}: SwitchCriteriaDetailProps) => {
    const incotermType =
        criteria_configurations.first_value === 'true' ? 'DDP' : 'DDU'
    const incotermDescription =
        criteria_configurations.first_value === 'true'
            ? 'Delivery Duty Paid'
            : 'Delivery Duty Unpaid'

    return (
        <div className="flex items-center mb-2">
            <img src={ddpIcon} alt={`${name} icon`} />
            <h3 className="text-[#141A1F] text-[14px] font-normal ml-2 ">
                {incotermType}:
                <span className="ml-2 bg-[#F1F5F9] text-[#3E5060] rounded px-2 py-1 text-sm">
                    {incotermDescription}
                </span>
            </h3>
        </div>
    )
}
